import { yupResolver } from '@hookform/resolvers/yup';
import { AlertBanner, AlertBannerStatus, LoginButton, TextField } from '@tryhackme/thm-ui-components';
import { useEffect, useState } from 'react';
import * as yup from 'yup';
import { useForm } from 'src/common/form';
import { StyledFormControl, StyledRegisterLink } from 'src/features/login/components/login-form/login-form.styles';
import { MagicLoginError } from 'src/features/login/components/magic-login-form/magic-login-form.constants';
import { useGetMagicStatusQuery, useSendMagicRequestMutation } from 'src/features/login/components/magic-login-form/magic-login-form.slice';
import { StyledFormSubtitle, StyledFormTitle } from 'src/features/login/login.styles';
import { EMPTY_EMAIL_ERROR, INVALID_EMAIL_ERROR } from 'src/features/signup/components/signup-form/signup-form.constants';
import { StyledForm, StyledFullWidthButton, StyledLinkSent, StyledMagicLoginForm } from './magic-login-form.styles';
import type { MagicLoginFormValues } from './magic-login-form.types';
export const MagicLoginForm = () => {
  const [magicLoginError, setMagicLoginError] = useState<string | null>(null);
  const [linkSent, setLinkSent] = useState(false);
  const {
    data
  } = useGetMagicStatusQuery(null);
  const [requestMagicLink] = useSendMagicRequestMutation();
  useEffect(() => {
    if (data?.data?.message) {
      setMagicLoginError(MagicLoginError[data.data.message] ?? MagicLoginError.UNHANDLED_ERROR);
    }
  }, [data]);
  const {
    handleSubmit,
    formState: {
      errors
    },
    register,
    reset
  } = useForm<MagicLoginFormValues>({
    resolver: yupResolver(yup.object({
      email: yup.string().email(INVALID_EMAIL_ERROR).required(EMPTY_EMAIL_ERROR)
    }))
  });
  const {
    email: emailError
  } = errors;
  const handleMagicLinkRequest = (formValues: MagicLoginFormValues) => {
    setMagicLoginError(null);
    requestMagicLink(formValues.email).unwrap().then(resp => {
      if (resp.status === 'error') {
        setMagicLoginError(MagicLoginError.UNHANDLED_ERROR);
      } else {
        setLinkSent(true);
      }
    }).catch(() => {});
    reset();
  };
  return <>
      <StyledMagicLoginForm linkSent={linkSent} data-testid="magic-login-form-card" data-sentry-element="StyledMagicLoginForm" data-sentry-source-file="magic-login-form.tsx">
        {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
        <StyledForm onSubmit={handleSubmit(handleMagicLinkRequest)} data-sentry-element="StyledForm" data-sentry-source-file="magic-login-form.tsx">
          <header>
            <StyledFormTitle data-sentry-element="StyledFormTitle" data-sentry-source-file="magic-login-form.tsx">Login - Magic Link</StyledFormTitle>
            <StyledFormSubtitle data-sentry-element="StyledFormSubtitle" data-sentry-source-file="magic-login-form.tsx">Welcome back!</StyledFormSubtitle>
          </header>
          {magicLoginError && <AlertBanner status={AlertBannerStatus.ERROR} message={magicLoginError} />}
          <StyledFormControl data-sentry-element="StyledFormControl" data-sentry-source-file="magic-login-form.tsx">
            <TextField {...register('email')} autoComplete="on" id="email-field" label="Email" placeholder="example@example.com" type="text" variant="input" isError={!!emailError?.message} errorMessage={emailError?.message as string} data-sentry-element="TextField" data-sentry-source-file="magic-login-form.tsx" />
          </StyledFormControl>
          <StyledFullWidthButton type="submit" data-sentry-element="StyledFullWidthButton" data-sentry-source-file="magic-login-form.tsx">Send Link</StyledFullWidthButton>
          <p>
            Don&apos;t have an account? <StyledRegisterLink to="/signup" data-sentry-element="StyledRegisterLink" data-sentry-source-file="magic-login-form.tsx">Sign up</StyledRegisterLink>.
          </p>
        </StyledForm>
      </StyledMagicLoginForm>
      <StyledLinkSent linkSent={linkSent} data-testid="link-sent-card" data-sentry-element="StyledLinkSent" data-sentry-source-file="magic-login-form.tsx">
        <header>
          <StyledFormTitle data-sentry-element="StyledFormTitle" data-sentry-source-file="magic-login-form.tsx">Check your inbox.</StyledFormTitle>
        </header>
        <p>If you have an account, you&apos;ll receive an email with a link to get you signed in quickly.</p>
        <LoginButton variant="outlined" fillSpace data-sentry-element="LoginButton" data-sentry-source-file="magic-login-form.tsx">
          Back to Log in
        </LoginButton>
        <p>Didn&apos;t receive an email? Check your spam folder or try with another email.</p>
      </StyledLinkSent>
    </>;
};